import React, { Component } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";

export default class Indicator extends Component {
  static propTypes = {
    isStatus: PropTypes.string,
    isSmall: PropTypes.bool
  };
  static defaultProps = {
    isStatus: "online",
    isSmall: false
  };
  render() {
    const { isStatus, isSmall } = this.props;
    return <Wrapper isStatus={isStatus} isSmall={isSmall} />;
  }
}

const Wrapper = styled.div`
  border-radius: 50%;
  width: 15px;
  height: 15px;
  ${props =>
    props.isStatus === "online" &&
    css`
      background: green;
    `};
  ${props =>
    props.isStatus === "offline" &&
    css`
      background: grey;
    `};
  ${props =>
    props.isStatus === "idle" &&
    css`
      background: yellow;
    `};
  ${props =>
    props.isSmall &&
    css`
      width: 10px;
      height: 10px;
    `};
`;



// WEBPACK FOOTER //
// ./src/module-common/Indicator.js